import React from 'react';

const Vue_v_text = () => {
  return (
    <div>
      <h1>Vue_v_text Component</h1>
      <p>This is the Vue_v_text tutorial page.</p>
    </div>
  );
}

export default Vue_v_text;
